import { GameProviderSlug } from '@game/types'
import { PROVIDER_MAGNET, PROVIDER_EVOLUTION, PROVIDER_PARIPLAY, PROVIDER_GAMES_GLOBAL, PROVIDER_PRAGMATIC } from '@playgame/constants'

const isMagnet = (provider: number | GameProviderSlug): boolean => provider === PROVIDER_MAGNET || String(provider)?.toLowerCase() === GameProviderSlug.MAGNET
const isEvolution = (provider: number | GameProviderSlug): boolean => provider === PROVIDER_EVOLUTION || String(provider)?.toLowerCase() === GameProviderSlug.EVOLUTION
const isPariplay = (provider: number | GameProviderSlug): boolean => provider === PROVIDER_PARIPLAY || String(provider)?.toLowerCase() === GameProviderSlug.PARIPLAY
const isGamesGlobal = (provider: number | GameProviderSlug): boolean => provider === PROVIDER_GAMES_GLOBAL || String(provider)?.toLowerCase() === GameProviderSlug.GAMES_GLOBAL
const isPragmatic = (provider: number | GameProviderSlug): boolean => provider === PROVIDER_PRAGMATIC || String(provider)?.toLowerCase() === GameProviderSlug.PRAGMATIC

const hasColdStartCreditInsert = (provider: number | GameProviderSlug): boolean => isPragmatic(provider) || isGamesGlobal(provider)

export default {
    isEvolution,
    isMagnet,
    isPariplay,
    isGamesGlobal,
    isPragmatic,
    hasColdStartCreditInsert
}
